import { Async } from '@lexriver/async'
import { DomeComponent, DomeManipulator, React } from '@lexriver/dome'
import { Settings } from '../../Settings'
import cssAnimation from '../Animation.m.scss'
import { IBasket } from '../Basket/IBasket'
import { EnumThumbnailWidth } from '../enums/EnumThumbnailWidth'
import { GlobalBasket } from '../GlobalBasket'
import { GlobalUser } from '../GlobalUser'
import { JsonBasketProductInfo } from '../json-data-types/JsonBasketProductInfo'
import { getMaxProductQuantity, JsonBasketRow } from '../json-data-types/JsonBasketRow'
import { getImageUrlForThumbImage, JsonProduct } from '../json-data-types/JsonProduct'
import { ServerProducts } from '../server-queries/ServerProducts'
import { UrlGenerator } from '../UrlGenerator'
import css from './BasketRow.m.scss'
import { BasketRowPriceSum } from './BasketRowPriceSum'
import { Checkbox } from './form/Checkbox'
import { Link } from './Link'
import { LoadingSpinnerForButton } from './LoadingSpinnerForButton'
import { ProductChosenAttributes } from './ProductChosenAttributes'
import { QuantityChanger } from './QuantityChanger'
//import { Scroller } from '../Scroller'

interface Attrs{
    basketRow:JsonBasketRow
    scrollIntoView:boolean
}

export class BasketRow extends DomeComponent<Attrs>{
    protected refContainer!:HTMLDivElement
    product:JsonProduct|undefined
    quantityChanger:QuantityChanger|undefined
    comWholesaleSum:BasketRowPriceSum|undefined
    comRetailSum:BasketRowPriceSum|undefined
    async init(){
    }

    render(){
        return <div ref={ref => this.refContainer = ref} class={css.basketRow}>
            <LoadingSpinnerForButton />
        </div>
    }

    async afterRender(){
        this.product = this.attrs.basketRow.product

        if(!this.product) {
            console.error('no product in attrs of', this.attrs.basketRow)
            return
        }

        if(!this.product.thumbnailImage){
            console.error('no thumbnail image for product', this.product)
            throw new Error('no thumbnail')
        }

        const canSeeWholesalePrices = await GlobalUser.checkIfCanSeeWholesalePricesAsync()
        const basket:IBasket = await GlobalBasket.getCurrentBasketAsync()
        const maxQuantity = getMaxProductQuantity({product:this.product, chosenAttributes: this.attrs.basketRow.productChosenAttributes})
        //this.scheduleUpdate()
        await DomeManipulator.replaceAllChildrenAsync(this.refContainer, 
            <>
            
                <div class={css.checkboxContainer}>
                    <Checkbox 
                    isChecked={basket.checkIfProductIsMarkedToRemove(this.attrs.basketRow.product, this.attrs.basketRow.productChosenAttributes)}
                    onChange={async (isChecked:boolean) => { 
                        let productInfo:JsonBasketProductInfo = {
                            productId: this.attrs.basketRow.product.id,
                            chosenAttributes: this.attrs.basketRow.productChosenAttributes

                        }
                        
                        if(isChecked){
                            basket.markProductToRemove(this.attrs.basketRow.product, this.attrs.basketRow.productChosenAttributes)
                        } else {
                            basket.unmarkProductToRemove(this.attrs.basketRow.product, this.attrs.basketRow.productChosenAttributes)
                        }
                        
                    }} />
                </div>

            <div class={css.photoContainer}>

                {/* <div> */}
                    <Link url={UrlGenerator.product(this.product.url, this.product.id)}>
                        {/* <img src={Settings.getImageUrlForThumbImage(this.product.thumbImage)} /> */}
                        {/* <img src={Settings.getImageUrlForThumbImage(this.product.thumbnailImage, Settings.EnumThumbnailWidth.Big)} srcset={
                            Settings.getImageUrlForThumbImage(this.product.thumbnailImage, Settings.EnumThumbnailWidth.ExtraSmall)+` ${Settings.EnumThumbnailWidth.ExtraSmall}w, ` +
                            Settings.getImageUrlForThumbImage(this.product.thumbnailImage, Settings.EnumThumbnailWidth.Small)+` ${Settings.EnumThumbnailWidth.Small}w, ` +
                            Settings.getImageUrlForThumbImage(this.product.thumbnailImage, Settings.EnumThumbnailWidth.Medium)+` ${Settings.EnumThumbnailWidth.Medium}w, `
                        }  /> */}
                        <img src={getImageUrlForThumbImage(this.product, EnumThumbnailWidth.Large)} srcset={
                            // getImageUrlForThumbImage(this.product, EnumThumbnailWidth.ExtraLarge) + ` ${EnumThumbnailWidth.ExtraLarge}w, ` +
                            getImageUrlForThumbImage(this.product, EnumThumbnailWidth.Large) + ` ${EnumThumbnailWidth.Large}w, ` +
                            getImageUrlForThumbImage(this.product, EnumThumbnailWidth.ExtraSmall) + ` ${EnumThumbnailWidth.ExtraSmall}w, ` +
                            getImageUrlForThumbImage(this.product, EnumThumbnailWidth.Small) + ` ${EnumThumbnailWidth.Small}w, ` +
                            getImageUrlForThumbImage(this.product, EnumThumbnailWidth.Medium) + ` ${EnumThumbnailWidth.Medium}w, `
                        } alt={ServerProducts.getProductTitle(this.product)} />

                        

                        {/* <img src={Settings.getImageUrlForThumbImage(this.product.thumbnailImage, Settings.EnumThumbnailWidth.Big)} 
                            // width={`${Settings.EnumThumbnailWidth.Medium}px`} 
                            /> */}

                    </Link>

                {/* quantity */}
                <div class={css.quantityContainer}>
                    <QuantityChanger 
                        quantity={this.attrs.basketRow.quantity} 
                        minQuantity={1} 
                        maxQuantity={maxQuantity} 
                        onQuantityChange={(newQuantity:number) => this.onQuantityChangeAsync(newQuantity)}
                        ref={ref => this.quantityChanger = ref} 
                        />
                    {canSeeWholesalePrices && this.product.wholesalePrice &&
                        <div class={css.availableQuantity}>
                            максимум: {maxQuantity}
                        </div>
                    }
                </div>

                {/* </div> */}
            </div>
            <div class={css.productDataContainer}>


                {/* name */}
                <div class={css.nameContainer}>
                    {Settings.formatProductName({productName: this.product.name})}
                </div>

                {/* sku */}
                <div class={css.skuContainer}>
                    артикул: <strong>{this.product.sku}</strong>
                    {/* <div class={[css.doublePriceGrid]}>
                        <div>
                            <div class={css.label}>артикул</div>
                            <div class={css.value}>{this.product.sku}</div>
                        </div>
                    </div> */}
                </div>

                {/* attributes */}
                {this.attrs.basketRow.productChosenAttributes &&
                    <div class={css.attributesContainer}>
                        <ProductChosenAttributes attributes={this.attrs.basketRow.productChosenAttributes} />
                    </div>
                }

                {/* price */}
                {/* <div class={css.priceContainer}>
                    {GlobalUser.checkIfCanSeeWholesalePrices()
                        ?
                        <div class={[css.doublePriceGrid, css.price]}>
                            <div>
                                <div class={css.label}>опт</div>  <div class={css.value}><strong>{Settings.formatNumberToPrice(this.product.wholesalePrice)}</strong></div>
                                <div class={css.label}>розн</div> <div class={css.value}>{Settings.formatNumberToPrice(this.product.retailPrice)}</div>
                            </div>
                        </div>
                        :
                        <div class={css.price}>цена: {Settings.formatNumberToPrice(this.product.retailPrice)}</div>
                    }
                </div> */}


                {/* sum */}
                {canSeeWholesalePrices && this.product.wholesalePrice
                    ?
                    <div class={css.wholesaleSumContainer}>
                        <div class={[css.doublePriceGrid, css.price]}>
                            <BasketRowPriceSum type={'wholesale'} getPrefix={() => <>опт&nbsp;сумма</>} row={this.attrs.basketRow} ref={ref => this.comWholesaleSum = ref } showIf1Quantity={true} strong={true} />
                            <BasketRowPriceSum type={'retail'} getPrefix={() => <>розн&nbsp;сумма&nbsp;</>} row={this.attrs.basketRow} ref={ref => this.comRetailSum = ref} showIf1Quantity={true} />
                        </div>
                    </div>
                    :
                    <div class={css.retailSumContainer}>
                        <div class={[css.doublePriceGrid]}>
                            <BasketRowPriceSum type='retail' getPrefix={() => "сумма "} row={this.attrs.basketRow} ref={ref => this.comRetailSum = ref} showIf1Quantity={true} strong={true} />
                        </div>
                        
                        {/* {Settings.formatNumberToPrice(this.product.retailPrice * this.attrs.quantity)} */}
                    </div>
                }


                {/* delete */}
                <div class={css.deleteContainer}>
                    <a onClick={async () => { 
                        const basket:IBasket = await GlobalBasket.getCurrentBasketAsync()
                        await basket.removeAsync(this.attrs.basketRow.product, this.attrs.basketRow.productChosenAttributes) 
                    }}><span class="icon-trash-empty"></span>Удалить товар</a>
                </div>


            </div>
            

            {/* sku */}
            {/* <div class={css.skuContainer}>
                <Link url={UrlGenerator.product(this.product.id)}></Link>
            </div> */}
            

            {/* <div class={css.descriptionContainer}>
                {Settings.formatProductDescription(this.product.description)}
            </div> */}

            </>
        )

        if(this.attrs.scrollIntoView){
            DomeManipulator.scrollIntoView(this.refContainer)
            //void Scroller.scrollIntoViewAsync(this.refContainer) // no await
        }
    
        this.subscribeToBasketUpdate()
        this.subscribeToCouponUpdateEvent()
    }



    protected subscribeToCouponUpdateEvent(){
        GlobalBasket.onBasketCouponChangeEvent.subscribe(async () => {
            console.log('BasketRow.tsx', 'couponUpdate', this.attrs.basketRow)

            if(!this.comRetailSum) {
                console.warn('no comRetailSum')
                return
            }
            
            await this.comRetailSum.updateAsync()

            if(!this.comWholesaleSum) {
                // console.warn('no comWholesaleSum') // no comWholesaleSum for non-wholesale user
                return
            }
            
            await this.comWholesaleSum.updateAsync()

        })
    }

    protected subscribeToBasketUpdate(){
        GlobalBasket.onBasketUpdateEvent.subscribe(async () => {
            if(!DomeManipulator.isInDom(this.rootElement)) return {unsubscribe:true}
            const basket:IBasket = await GlobalBasket.getCurrentBasketAsync()
            const newQuantity = basket.getQuantity(
                this.attrs.basketRow.product,
                this.attrs.basketRow.productChosenAttributes
            )
            if(this.attrs.basketRow.quantity === newQuantity) return // no change
            //console.log('BasketRow on basket updated event', 'newQuantity=', newQuantity, 'oldQuantity=', this.attrs.quantity)
            if(newQuantity == 0){
                // remove this element
                await this.deleteThisRowAsync()
            } else {
                // update quantity, retailSum and wholesaleSum
                this.attrs.basketRow.quantity = newQuantity

                if(!this.quantityChanger) {
                    console.warn('no quantityChanger')
                    return
                }
                this.quantityChanger.setQuantity(newQuantity, false)
                
                if(!this.comRetailSum) {
                    console.warn('no comRetailSum')
                    return
                }
                //this.comRetailSum.attrs.row = newQuantity
                await this.comRetailSum.updateAsync()

                // if(!this.comWholesaleSum) {
                //     console.warn('no comWholesaleSum')
                //     return
                // }
                if(this.comWholesaleSum){
                    //this.comWholesaleSum.attrs.quantity = newQuantity
                    await this.comWholesaleSum.updateAsync()
                }
                
            }
        })

    }



    protected async onQuantityChangeAsync(newQuantity:number){
        //this.attrs.quantity = newQuantity
        const basket:IBasket = await GlobalBasket.getCurrentBasketAsync()
        await basket.changeQuantityAsync(this.attrs.basketRow.product, newQuantity, this.attrs.basketRow.productChosenAttributes)
    }

    protected async deleteThisRowAsync(){
        //DomeManipulator.addCssClass(this.rootElement, cssAnimation.fadeOut)
        //DomeManipulator.setCssClasses(this.rootElement, cssAnimation.fadeOut)
        this.rootElement.classList.add(cssAnimation.fadeOut300)
        await Async.waitMsAsync(300)
        //DomeManipulator.setCssClasses(this.rootElement, css.collapsed)
        this.rootElement.classList.add(css.collapsed)
        await Async.waitMsAsync(200)
        await DomeManipulator.removeElementAsync(this.rootElement)
        
    }

}

// class WholesaleSum extends DomeComponent<{product?:JsonProduct, quantity?:number}>{
//     render(){
//         if(!this.attrs.product || !this.attrs.quantity) return null
//         //return <div class={css.price}><strong>{Settings.formatNumberToPrice(this.attrs.product.wholesalePrice * this.attrs.quantity)}</strong></div>
//         return <span><strong>{Settings.formatNumberToPrice(this.attrs.product.wholesalePrice * this.attrs.quantity)}</strong></span>
//     }
// }



